import { useIntl } from 'react-intl'
import { UrgencyWaitCauseDTO, UrgencyWaitLevel } from '../../../dto/urgencySummary/UrgencySummaryDTO'
import { isCriticalUrgencyCause, MAX_CAUSES_SHOWN, urgencyCauseText } from '../urgencyCauseText'

interface UrgencyWaitCausesProps {
  causes: UrgencyWaitCauseDTO[]
  level: UrgencyWaitLevel
}

/**
 * Las posibles causas de la espera de una guardia, una por renglón (hasta tres). Son hipótesis a partir de los datos, no
 * un diagnóstico: sin ninguna y con la espera fuera de lo normal, lo dice. La espera de un código de Inmediato o Emergencia
 * por encima del objetivo va con un ícono y en negrita, así no depende solo del color.
 */
export default function UrgencyWaitCauses({ causes, level }: UrgencyWaitCausesProps) {
  const intl = useIntl()

  if (causes.length === 0) {
    return (
      <p className="nv-urg-causes nv-urg-causes--none">
        {level === 'OK' ? '—' : intl.formatMessage({ id: 'UrgencySummaryCauseNone' })}
      </p>
    )
  }

  return (
    <ul className="nv-urg-causes">
      {causes.slice(0, MAX_CAUSES_SHOWN).map((cause, index) => {
        const critical = isCriticalUrgencyCause(cause)
        return (
          <li key={`${cause.code}-${index}`} className={critical ? 'nv-urg-causes__item nv-urg-causes__item--critical' : 'nv-urg-causes__item'}>
            {critical && <i className="pi pi-exclamation-triangle" aria-hidden="true" />}
            <span>{urgencyCauseText(intl, cause)}</span>
          </li>
        )
      })}
    </ul>
  )
}
